import { administrationApiRtkQuery } from '@chillibean/administration-api-client-sdk';

// API Utils
export const { updateQueryData } = administrationApiRtkQuery.baseApi.util;

// API Slice
export const apiSlice = administrationApiRtkQuery.baseApi.enhanceEndpoints({
  endpoints: {
    updateSubjectRequirements(endpoint) {
      endpoint.onQueryStarted = async ({ accountId, body }, { dispatch, queryFulfilled }) => {
        // Optimistic update
        const updateResult = dispatch(updateQueryData('getSubjectRequirements', { accountId }, () => body.chapters));

        try {
          await queryFulfilled;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          updateResult.undo();
        }

        // Pessimistic update
        try {
          const { data } = await queryFulfilled;
          dispatch(updateQueryData('getSubjectRequirements', { accountId }, () => data));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      };
    },
  },
});

// API Hooks
export const { useGetSubjectRequirementsQuery, useUpdateSubjectRequirementsMutation } = apiSlice;
